import React from 'react';
import ReactDOM from 'react-dom/client';
import { QueryClientProvider } from '@tanstack/react-query';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import queryClient from './queryClient';
import { lockNativeViewportZoom } from './utils/nativeZoom';
import { restoreToken } from './services/tokenStore';

lockNativeViewportZoom();

// Recover the session token before AuthProvider reads it, so a WebView that lost
// its localStorage doesn't boot the reader to /login. Instant on the web.
restoreToken().finally(() => {
  const root = ReactDOM.createRoot(document.getElementById('root'));
  root.render(
    <React.StrictMode>
      <QueryClientProvider client={queryClient}>
        <App />
      </QueryClientProvider>
    </React.StrictMode>
  );
});

// Log Core Web Vitals (LCP/FCP/TTFB/CLS/FID) to the console for baselining.
reportWebVitals();
